import React, { Component } from 'react';
import { connect } from 'react-redux';
import HotelSummary from './HotelSummary';

class HotelsSummaries extends Component {
  render() {
    const { hotels, config, summaryType } = this.props;

    return (
      hotels &&
      hotels.map((hotel) => (
        <HotelSummary key={hotel.id} summaryType={summaryType} packagesSearchHotel={hotel} {...config} />
      ))
    );
  }
}

function mapStateToProps(state) {
  return {
    hotels: state.checkoutPagePackagesSearch.value && state.checkoutPagePackagesSearch.value.hotels,
  };
}

export default connect(mapStateToProps)(HotelsSummaries);
